/* Jagi theme — theme.js (sin dependencias) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  /* ---------------- Utils ---------------- */
  const fetchJSON = (url, opts = {}) =>
    fetch(url, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...opts }).then(async (r) => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw data;
      return data;
    });
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('is-visible'), 3200);
  };

  /* ---------------- Buttons: fill from cursor + magnet ---------------- */
  document.addEventListener('mouseover', (e) => {
    const b = e.target.closest('.button');
    if (!b || b.contains(e.relatedTarget)) return;
    const r = b.getBoundingClientRect();
    b.style.setProperty('--x', `${e.clientX - r.left}px`);
    b.style.setProperty('--y', `${e.clientY - r.top}px`);
    b.style.setProperty('--w', `${r.width}px`);
  });
  document.addEventListener('mouseout', (e) => {
    const b = e.target.closest('.button');
    if (!b || b.contains(e.relatedTarget)) return;
    const r = b.getBoundingClientRect();
    b.style.setProperty('--x', `${e.clientX - r.left}px`);
    b.style.setProperty('--y', `${e.clientY - r.top}px`);
  });

  if (fine && !reduced && document.body.dataset.magnet !== 'false') {
    $$('[data-magnet]').forEach((el) => {
      const strength = parseFloat(el.dataset.magnet) || 0.25;
      el.style.transition = 'transform .5s cubic-bezier(.3,1,.3,1)';
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * strength;
        const y = (e.clientY - r.top - r.height / 2) * strength;
        el.style.transform = `translate(${x}px, ${y}px)`;
      });
      el.addEventListener('mouseleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------------- Announcement ---------------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(() => {
      const cur = items[i];
      i = (i + 1) % items.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      items[i].classList.remove('is-leaving');
      items[i].classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 700);
    }, speed);
  });

  /* ---------------- Overlay ---------------- */
  const overlay = $('[data-page-overlay]');
  const overlayOn = (on) => overlay && overlay.classList.toggle('is-active', on);

  /* ---------------- Header ---------------- */
  const header = $('[data-header]');
  if (header) {
    const section = header.closest('.shopify-section');
    const sticky = header.dataset.sticky !== 'none';
    if (sticky && section) section.classList.add('is-sticky-section');

    const setHeight = () => {
      const groupH = $$('.shopify-section-group-header-group').reduce((a, s) => (s.classList.contains('is-sticky-section') ? a + s.offsetHeight : a), 0);
      root.style.setProperty('--header-height', `${groupH}px`);
    };
    setHeight();
    window.addEventListener('resize', setHeight);

    // Compact on scroll (as Quest): main menu collapses into burger
    if (sticky && header.dataset.compact === 'true') {
      let ticking = false;
      const onScroll = () => {
        const y = window.scrollY;
        const offset = section ? section.offsetTop : 0;
        header.classList.toggle('is-compact', y > offset + 120);
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
      new ResizeObserver(setHeight).observe(header);
    }

    // Sliding pill block behind menu items
    const menu = $('[data-menu]', header);
    if (menu) {
      const block = $('.menu__block', menu);
      const links = $$('.menu-link', menu);
      let current = null;
      const moveTo = (link) => {
        if (!block) return;
        links.forEach((l) => l.classList.toggle('is-highlighted', l === link));
        if (!link) { block.classList.remove('is-visible'); current = null; return; }
        const mr = menu.getBoundingClientRect();
        const lr = link.getBoundingClientRect();
        if (!current) { block.style.transition = 'none'; requestAnimationFrame(() => (block.style.transition = '')); }
        block.style.width = `${lr.width}px`;
        block.style.transform = `translateX(${lr.left - mr.left}px)`;
        block.style.top = `${lr.top - mr.top}px`;
        block.style.height = `${lr.height}px`;
        block.classList.add('is-visible');
        current = link;
      };
      links.forEach((l) => {
        l.addEventListener('mouseenter', () => moveTo(l));
        l.addEventListener('focus', () => moveTo(l));
      });
      menu.addEventListener('mouseleave', () => {
        const open = $('details[open] > .menu-link', menu);
        moveTo(open || null);
      });

      // Hover dropdowns
      $$('details[data-dropdown]', menu).forEach((d) => {
        const summary = $('summary', d);
        let t;
        const open = () => {
          clearTimeout(t);
          $$('details[data-dropdown][open]', menu).forEach((o) => o !== d && o.removeAttribute('open'));
          d.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          overlayOn(true);
          const mega = $('.dropdown--mega', d);
          if (mega) mega.style.top = `${header.getBoundingClientRect().bottom}px`;
        };
        const close = () => {
          t = setTimeout(() => {
            d.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
            if (!$('details[data-dropdown][open]', menu)) overlayOn(false);
          }, 120);
        };
        d.addEventListener('mouseenter', open);
        d.addEventListener('mouseleave', close);
        summary.addEventListener('click', (e) => {
          // Click navigates if link present and dropdown already open (desktop)
          const href = summary.dataset.href;
          if (fine && href && d.hasAttribute('open')) { e.preventDefault(); window.location.href = href; return; }
          if (!fine) { e.preventDefault(); d.hasAttribute('open') ? close() : open(); }
          else e.preventDefault();
        });
        d.addEventListener('focusout', (e) => { if (!d.contains(e.relatedTarget)) close(); });
        d.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); summary.focus(); } });
      });
    }
  }
  overlay && overlay.addEventListener('click', () => {
    $$('details[data-dropdown][open]').forEach((d) => d.removeAttribute('open'));
    overlayOn(false);
  });

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const f = $('[autofocus], input[type=search], .drawer__close', d);
    setTimeout(() => f && f.focus(), 120);
    d.dispatchEvent(new CustomEvent('drawer:open'));
  };
  const closeDrawer = (d) => {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open')) document.body.classList.remove('no-scroll');
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  window.theme.openDrawer = openDrawer;
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && window.theme.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
    const mOpen = e.target.closest('[data-modal-open]');
    if (mOpen) {
      e.preventDefault();
      const m = document.getElementById(mOpen.dataset.modalOpen);
      if (m) { m.classList.add('is-open'); document.body.classList.add('no-scroll'); }
    }
    const mClose = e.target.closest('[data-modal-close]');
    if (mClose) {
      const m = mClose.closest('.modal');
      m.classList.remove('is-open');
      if (!$('.drawer.is-open, .modal.is-open')) document.body.classList.remove('no-scroll');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('.modal.is-open').forEach((m) => m.classList.remove('is-open'));
    document.body.classList.remove('no-scroll');
  });

  /* ---------------- Slideshow ---------------- */
  const initSlideshow = (el) => {
    const slides = $$('.slide', el);
    const dots = $$('.slideshow__dot', el);
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
      slides[i].setAttribute('aria-hidden', 'false');
    };
    const auto = el.dataset.autoplay === 'true';
    const speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
    const play = () => { if (!auto) return; clearInterval(timer); timer = setInterval(() => go(i + 1), speed); };
    $('[data-prev]', el) && $('[data-prev]', el).addEventListener('click', () => { go(i - 1); play(); });
    $('[data-next]', el) && $('[data-next]', el).addEventListener('click', () => { go(i + 1); play(); });
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); play(); }));
    el.addEventListener('mouseenter', () => clearInterval(timer));
    el.addEventListener('mouseleave', play);
    // swipe
    let sx = null;
    el.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    el.addEventListener('touchend', (e) => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); }
      sx = null;
    });
    play();
  };
  $$('[data-slideshow]').forEach(initSlideshow);

  /* ---------------- Marquee pause ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-marquee-toggle]');
    if (!b) return;
    const m = document.getElementById(b.getAttribute('aria-controls'));
    const paused = m.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', paused);
    $('[data-label]', b).textContent = paused ? b.dataset.play : b.dataset.pause;
    $('[data-icon-pause]', b).hidden = paused;
    $('[data-icon-play]', b).hidden = !paused;
  });

  /* ---------------- Carousels + tabs ---------------- */
  const bindCarousel = (wrap) => {
    const prev = $('[data-carousel-prev]', wrap);
    const next = $('[data-carousel-next]', wrap);
    const active = () => $$('[data-carousel]', wrap).find((c) => !c.closest('[hidden]'));
    const update = () => {
      const c = active();
      if (!c || !prev) return;
      prev.disabled = c.scrollLeft < 5;
      next.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 5;
    };
    const step = (dir) => { const c = active(); c && c.scrollBy({ left: dir * c.clientWidth * 0.9, behavior: 'smooth' }); };
    prev && prev.addEventListener('click', () => step(-1));
    next && next.addEventListener('click', () => step(1));
    $$('[data-carousel]', wrap).forEach((c) => c.addEventListener('scroll', update, { passive: true }));
    $$('[role=tab]', wrap).forEach((tab) => {
      tab.addEventListener('click', () => {
        $$('[role=tab]', wrap).forEach((t) => t.setAttribute('aria-selected', t === tab));
        $$('[role=tabpanel]', wrap).forEach((p) => (p.hidden = p.id !== tab.getAttribute('aria-controls')));
        const cta = $('[data-tab-cta]', wrap);
        if (cta && tab.dataset.url) cta.href = tab.dataset.url;
        update();
      });
    });
    update();
    window.addEventListener('resize', update);
  };
  $$('[data-carousel-wrap]').forEach(bindCarousel);

  /* ---------------- Reveal ---------------- */
  if ('IntersectionObserver' in window && document.body.dataset.reveal === 'true') {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------------- Cart ---------------- */
  const cartSections = () => {
    const ids = $$('[data-cart-section]').map((el) => el.dataset.cartSection);
    return [...new Set(['cart-drawer', ...ids])];
  };
  const renderCartSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = parseHTML(html);
      $$(`[data-cart-section="${id}"]`).forEach((target) => {
        const fresh = $(`[data-cart-section="${id}"]`, doc);
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
      const countEl = $('[data-cart-count-value]', doc);
      if (countEl) {
        const n = parseInt(countEl.dataset.cartCountValue, 10) || 0;
        $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.hidden = n === 0; });
      }
    });
  };
  const addToCart = async (items, button) => {
    button && button.classList.add('is-loading');
    try {
      const res = await fetchJSON(window.theme.routes.cartAdd + '.js', {
        method: 'POST',
        body: JSON.stringify({ items, sections: cartSections(), sections_url: window.location.pathname })
      });
      renderCartSections(res.sections);
      if (window.theme.cartType === 'drawer') openDrawer('CartDrawer');
      else window.location.href = window.theme.routes.cart;
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      toast(err.description || err.message || window.theme.strings.error);
    } finally {
      button && button.classList.remove('is-loading');
    }
  };
  const changeLine = async (line, quantity, el) => {
    const item = el && el.closest('.cart-item');
    item && item.classList.add('is-loading');
    try {
      const res = await fetchJSON(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        body: JSON.stringify({ line, quantity, sections: cartSections(), sections_url: window.location.pathname })
      });
      renderCartSections(res.sections);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      toast(err.description || err.message || window.theme.strings.error);
      item && item.classList.remove('is-loading');
    }
  };
  window.theme.addToCart = addToCart;

  document.addEventListener('click', (e) => {
    const qb = e.target.closest('[data-qty-btn]');
    if (qb) {
      const wrap = qb.closest('.qty');
      const input = $('input', wrap);
      const min = parseInt(input.min, 10) || 0;
      const v = Math.max(min, (parseInt(input.value, 10) || 0) + (qb.dataset.qtyBtn === 'plus' ? 1 : -1));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.cartRemove, 10), 0, rm); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }], quick); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (input) changeLine(parseInt(input.dataset.cartQty, 10), parseInt(input.value, 10) || 0, input);
    const note = e.target.closest('[data-cart-note]');
    if (note) fetchJSON(window.theme.routes.cartUpdate + '.js', { method: 'POST', body: JSON.stringify({ note: note.value }) });
  });

  /* ---------------- Product form ---------------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form.product-form', root);
    const idInput = form && $('input[name=id]', form);
    const sectionId = root.dataset.sectionId;
    const updateUrl = root.dataset.updateUrl !== 'false';

    const selected = () => $$('[data-option-index]', root).map((fs) => {
      const c = $('input:checked', fs);
      return c ? c.value : null;
    });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const markAvailability = () => {
      const cur = selected();
      $$('[data-option-index]', root).forEach((fs) => {
        const idx = parseInt(fs.dataset.optionIndex, 10);
        $$('input', fs).forEach((inp) => {
          const test = cur.slice(); test[idx] = inp.value;
          const exact = findVariant(test);
          const ok = exact
            ? exact.available
            : product.variants.some((vv) => vv.available && vv.options[idx] === inp.value && vv.options.every((o, i) => i >= idx || o === cur[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
        const label = $('[data-selected-value]', fs);
        const c = $('input:checked', fs);
        if (label && c) label.textContent = c.value;
      });
    };

    const swap = async (variant) => {
      if (!sectionId) return;
      try {
        const url = `${root.dataset.url}?variant=${variant.id}&section_id=${sectionId}`;
        const html = await fetch(url).then((r) => r.text());
        const doc = parseHTML(html);
        $$('[data-swap]', root).forEach((el) => {
          const fresh = $(`[data-swap="${el.dataset.swap}"]`, doc);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      } catch (e) { /* noop */ }
    };

    const setButtons = (variant) => {
      $$('[data-add-button]', root.ownerDocument).forEach((b) => {
        if (b.closest('[data-product]') !== root && !b.closest('.sticky-atc')) return;
        const label = $$('.btn-roll > span', b);
        let text = window.theme.strings.addToCart;
        if (!variant) text = window.theme.strings.unavailable;
        else if (!variant.available) text = window.theme.strings.soldOut;
        label.forEach((s) => (s.textContent = text));
        b.disabled = !variant || !variant.available;
      });
    };

    const onChange = () => {
      markAvailability();
      const variant = findVariant(selected());
      setButtons(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', u.toString());
      }
      if (variant.featured_media) {
        const slide = $(`[data-media-id="${variant.featured_media.id}"]`, root);
        if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      const wa = $('[data-whatsapp-product]', root);
      if (wa) {
        const base = wa.dataset.base;
        const msg = `${wa.dataset.msg} ${product.title} - ${variant.title} ${window.location.href}`;
        wa.href = `${base}?text=${encodeURIComponent(msg)}`;
      }
      swap(variant);
    };
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) onChange(); });
    markAvailability();

    form && form.addEventListener('submit', (e) => {
      if (window.theme.cartType !== 'drawer') return;
      e.preventDefault();
      const qty = parseInt(($('[name=quantity]', form) || {}).value, 10) || 1;
      const props = {};
      new FormData(form).forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      addToCart([{ id: parseInt(idInput.value, 10), quantity: qty, properties: props }], $('[data-add-button]', form));
    });

    // Gallery
    const main = $('[data-gallery-main]', root);
    if (main) {
      const thumbs = $$('[data-thumb]', root);
      const dots = $$('[data-gallery-dots] span', root);
      thumbs.forEach((t, n) => t.addEventListener('click', () => {
        const s = main.children[n];
        main.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      }));
      let raf;
      main.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const n = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach((t, k) => t.classList.toggle('is-active', k === n));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
          const at = thumbs[n];
          at && at.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }, { passive: true });
      if (fine) {
        $$('.gallery__slide[data-zoom]', main).forEach((s) => {
          s.addEventListener('click', () => s.classList.toggle('is-zoomed'));
          s.addEventListener('mousemove', (e) => {
            const r = s.getBoundingClientRect();
            s.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`);
            s.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`);
          });
          s.addEventListener('mouseleave', () => s.classList.remove('is-zoomed'));
        });
      }
    }

    // Sticky add to cart
    const sticky = $('[data-sticky-atc]');
    const mainBtn = form && $('[data-add-button]', form);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(mainBtn);
      $('button', sticky).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
  });

  /* ---------------- Predictive search ---------------- */
  $$('[data-predictive-search]').forEach((wrap) => {
    const input = $('input[type=search]', wrap);
    const results = $('[data-predictive-results]', wrap);
    let ctrl, t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article,query&resources[limit]=10&section_id=predictive-search`;
          const html = await fetch(url, { signal: ctrl.signal }).then((r) => r.text());
          const doc = parseHTML(html);
          const fresh = $('#shopify-section-predictive-search', doc);
          results.innerHTML = fresh ? fresh.innerHTML : '';
        } catch (e) { /* aborted */ }
      }, 220);
    });
  });

  /* ---------------- Facets ---------------- */
  $$('[data-facets-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('[type=number]')) return;
      submitFacets(form);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); submitFacets(form); });
  });
  function submitFacets(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
    window.location.search = params.toString();
  }
  $$('[data-sort-select]').forEach((sel) => sel.addEventListener('change', () => {
    const u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }));
})();
